module.exports = __webpack_public_path__ + "static/media/cert_139.490563cf.jpg";